module.exports = __webpack_public_path__ + "static/media/xiraForLawyers2.1f6ca08a.mp4";